<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 09:39:28
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-15 14:58:26
 * @Description: 营销内容-话术库
 -->
<template>
  <div class="speech-storehouse">
    <div class="top-tabs">
      <mk-tabs-biz
        v-model="activeName"
        class="el-tabs-mk-ui"
      >
        <mk-tab-pane
          v-for="(item, index) in tabs"
          :key="index"
          :label="item.label"
          :name="item.name"
        >
        </mk-tab-pane>
      </mk-tabs-biz>
    </div>
    <div class="main-state">
      <component
        :is="activeName"
        :commodity-tags-options="commodityTagsOptions"
        @change-tags-options="changTagsOptions"
        @update="pCommodityTagGet"
      ></component>
    </div>
  </div>
</template>

<script>
import QuestionBank from './components/question-bank'
import CommonLanguage from './components/common-language'
export default {
  name: 'SpeechStorehouse',
  components: {
    QuestionBank,
    CommonLanguage
  },
  data () {
    return {
      // 当前tab名
      activeName: 'questionBank',
      tabs: [
        {
          label: '百问百答',
          name: 'questionBank'
        },
        {
          label: '常用语',
          name: 'commonLanguage'
        }
      ],
      commodityTagsOptions: []
    }
  },
  async created () {
    await this.pCommodityTagGet()
  },
  methods: {
    // 获取全部商品标签
    async pCommodityTagGet () {
      let res = await CONVERSATIONAPIS.CommodityTagApi.pCommodityTagGet({})
      if (res.success) {
        this.commodityTagsOptions = res.data.data
      }
    },
    changTagsOptions () {
      // this.commodityTagsOptions = data
      this.pCommodityTagGet()
    }
  }
}
</script>

<style lang="scss" scoped>
.speech-storehouse {
  display: flex;
  flex-direction: column;
  height: 100%;

  .main-state {
    flex: 1;
    height: 100%;
    overflow: hidden;
  }

  // /deep/ .el-tabs__nav-scroll {
  //   .el-tabs__item {
  //     font-size: 14px;
  //     height: 60px;
  //     line-height: 60px;
  //     padding: 0 22px;
  //     font-weight: 500;
  //   }

  //   .el-tabs__item.is-active {
  //     color: #009cff !important;
  //   }

  //   .el-tabs__active-bar {
  //     background: #009cff !important;
  //   }
  // }

  // /deep/ .el-tabs__active-bar {
  //   padding: 0 10px;
  //   margin-left: -10px;
  // }

  // /deep/ .el-tabs__nav-wrap {
  //   padding: 0 !important;
  // }
}
</style>
